// extracted by mini-css-extract-plugin
export default {"block":"Header_block__S2NlK","header":"Header_header__1pTt+","logoblock":"Header_logoblock__wEMnN","rightbar":"Header_rightbar__BrW3U","nav":"Header_nav__6podK"};